import {assertTokenValidForMutation, handleResponse} from "@/services/service-helpers.ts";
import {MileageRate} from "@/models/mileage-rate.ts";
import log from '@/lib/logger';

const NBH_MILEAGE_RATES_ADMIN_BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/admin/mileage-rates`;
const NBH_MILEAGE_RATES_USER_BASE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/mileage-rates`;

export async function getAllMileageRates(token: string | null): Promise<MileageRate[] | void> {
    if (!token) {
        log.error("No token provided for mileage rates retrieval.");
        return Promise.reject("No token provided");
    }

    const response = await fetch(NBH_MILEAGE_RATES_ADMIN_BASE_URL, {
        method: "GET",
        headers: new Headers({
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        })
    });

    return handleResponse<MileageRate[]>(response);
}

export async function getCurrentMileageRate(token: string | null): Promise<MileageRate | null | void> {
    if (!token) {
        log.error("No token provided for current mileage rate retrieval.");
        return Promise.reject("No token provided");
    }

    const response = await fetch(`${NBH_MILEAGE_RATES_USER_BASE_URL}/current`, {
        method: "GET",
        headers: new Headers({
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        })
    });

    if (response.status === 204) {
        return null;
    }

    return handleResponse<MileageRate>(response);
}

export async function createMileageRate(
    token: string | null,
    amountPerKm: number
): Promise<MileageRate | void> {
    if (!token) {
        log.error("No token provided for mileage rate creation.");
        return Promise.reject("No token provided");
    }
    assertTokenValidForMutation()

    const response = await fetch(NBH_MILEAGE_RATES_ADMIN_BASE_URL, {
        method: "POST",
        headers: new Headers({
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        }),
        body: JSON.stringify({amountPerKm})
    });

    return handleResponse<MileageRate>(response);
}

export async function updateMileageRate(
    token: string | null,
    amountPerKm: number
): Promise<MileageRate | void> {
    return createMileageRate(token, amountPerKm);
}
